import { render } from "./ShipmentsComponent.vue?vue&type=template&id=7b7749bb&scoped=true"
import script from "./ShipmentsComponent.vue?vue&type=script&lang=js"
export * from "./ShipmentsComponent.vue?vue&type=script&lang=js"

import "./ShipmentsComponent.vue?vue&type=style&index=0&id=7b7749bb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7749bb"]])

export default __exports__